'use client';
import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { zIndexUtil } from '../../helpers/zIndexUtil.js';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { Button } from '../Button/Button.js';

const SkipLinkButton = styled(Button).withConfig({
  componentId: "sc-104m262-0"
})(["left:-999px;position:absolute;overflow:hidden;z-index:", ";&:active,&:focus,&:hover{left:auto;overflow:auto;z-index:", ";}"], zIndexUtil.skipLink, zIndexUtil.skipLinkActive);
const SkipLink = /*#__PURE__*/withTitan(({
  withPositioning,
  target,
  onClick,
  onFocus,
  onBlur,
  label
}) => {
  const ButtonComponent = withPositioning ? SkipLinkButton : Button;
  return jsx(ButtonComponent, {
    href: target,
    size: "S",
    variant: "clear",
    onBlur: onBlur,
    onClick: onClick,
    onFocus: onFocus,
    children: label
  });
}, {
  name: 'SkipLink'
});

export { SkipLink };
//# sourceMappingURL=SkipLink.js.map
